import { I18nService } from "@perxis-auto/shared/lib/services/I18nService";
import { APP } from "../../../shared/config/app.js";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
const GET_DEFAULT_SPECIFICATION_ITEM_SCHEMES = () => {
  const { i18n } = I18nService.getInstance();
  return [
    { id: "engine", key: "engine", label: i18n.t("config.specification.engine", { ns: APP.name }) },
    { id: "gearbox", key: "gearbox", label: i18n.t("config.specification.gearbox", { ns: APP.name }) },
    { id: "drivetrain", key: "drivetrain", label: i18n.t("config.specification.drivetrain", { ns: APP.name }) },
    { id: "version", key: "version", label: i18n.t("config.specification.version", { ns: APP.name }) },
    { id: "exterior", key: "exterior", label: i18n.t("config.specification.exterior", { ns: APP.name }) },
    { id: "interior", key: "interior", label: i18n.t("config.specification.interior", { ns: APP.name }) },
    { id: "vin", key: "vin", label: i18n.t("config.specification.vin", { ns: APP.name }) }
  ];
};
const GET_DEFAULT_CONTAINER_PROPS = () => ({
  schemes: GET_DEFAULT_SPECIFICATION_ITEM_SCHEMES()
});
export {
  GET_DEFAULT_CONTAINER_PROPS,
  GET_DEFAULT_SPECIFICATION_ITEM_SCHEMES
};
